
import React  from 'react';
import { StudentScore } from '_components/studentScoreList'

export { PersonalScore };

function PersonalScore() {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');

    return (
        <div>
            <StudentScore student_id={userData?.student_id} isPersonal={true} />
        </div>
    )

}